// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__kqUDi","question":"Question_question__2axhG","description":"Question_description__1w6XD"};